import React, { useState, useEffect, useCallback } from 'react';
import {
  Card, CardContent, Table, TableHead, TableRow, TableCell, TableBody,
  IconButton, Tooltip, TablePagination,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import PageHeader from '../../components/Common/PageHeader';
import { getBookRequestsApi } from '../../api/books';

function formatAmount(value) {
  return value === 'NA' || value == null ? 'NA' : `₹${value}`;
}

export default function BookRequests() {
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const fetchRequests = useCallback(async () => {
    const res = await getBookRequestsApi({ page: page + 1, page_size: rowsPerPage });
    setRequests(res.data.results || res.data);
    setTotal(res.data.count || res.data.length);
  }, [page, rowsPerPage]);

  useEffect(() => { fetchRequests(); }, [fetchRequests]);

  return (
    <Layout title="Book Requests">
      <PageHeader
        title="Book Requests"
        breadcrumbs={[{ label: 'Admin' }, { label: 'Book Requests' }]}
      />
      <Card>
        <CardContent>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Requested By</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Project Name</TableCell>
                <TableCell>Expected Price per Book</TableCell>
                <TableCell>Minimum Value per Publisher</TableCell>
                <TableCell>No. of Books Requested</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requests.map((r) => (
                <TableRow key={r.id} hover>
                  <TableCell>{r.requested_by_name}</TableCell>
                  <TableCell>{r.requested_by_email}</TableCell>
                  <TableCell>{r.project_name}</TableCell>
                  <TableCell>{formatAmount(r.expected_price_per_book)}</TableCell>
                  <TableCell>{formatAmount(r.minimum_value_per_publisher)}</TableCell>
                  <TableCell>{r.books_count}</TableCell>
                  <TableCell>
                    <Tooltip title="View Books Details">
                      <IconButton size="small" color="primary" onClick={() => navigate(`/admin/book-requests/${r.id}/books`)}>
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination component="div" count={total} page={page} rowsPerPage={rowsPerPage}
            onPageChange={(_, p) => setPage(p)}
            onRowsPerPageChange={(e) => { setRowsPerPage(+e.target.value); setPage(0); }}
            rowsPerPageOptions={[10, 25, 50, 100]} />
        </CardContent>
      </Card>
    </Layout>
  );
}
